import { useCallback } from "react";
import { axios } from "../axios";

export const useRemoveSocialOfferSpotlight = () => {
  const [state, execute, cancel] = axios(
    {
      method: "patch",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/offers/social/spotlight/remove/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
